// extracted by mini-css-extract-plugin
export default {"DownloadLink":"DownloadItem_DownloadLink__txVk7","DownloadIcon":"DownloadItem_DownloadIcon__M9z0d"};